module.exports = __webpack_public_path__ + "static/media/MK.e3658f78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MK.svg
// module id = 2208
// module chunks = 7